var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "OrderDetails",
      staticStyle: {
        padding: "20px 5px",
        background: "#ffffff",
        "box-shadow": "rgb(107 105 105 / 21%) 0px 0px 20px 0px",
        "border-radius": "10px"
      }
    },
    [
      _c(
        "p",
        {
          staticClass: "comeback",
          on: {
            click: function($event) {
              return _vm.comeback()
            }
          }
        },
        [
          _c("span", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("i18n_Return")))])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "RequestInfo divbox",
          staticStyle: { margin: "3px 29px", width: "95%" }
        },
        [
          _c("h4", [_vm._v(_vm._s(_vm.$t("i18n_Order_info")))]),
          _vm._v(" "),
          _vm.Alldata.waybilldetails
            ? _c("ul", { staticClass: "RI_ul" }, [
                _c("li", [
                  _c("p", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("i18n_Tracking_number")))
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.routes.nos || "-"))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("i18n_Destination")))]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.Alldata.message.pod_country || "-") +
                          "\n            " +
                          _vm._s(
                            _vm.Alldata.message.rece_city
                              ? "- " + _vm.Alldata.message.rece_city
                              : ""
                          ) +
                          "\n          "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("p", { staticStyle: { visibility: "hidden" } }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("i18n_cargo_classification")) + " ")
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.Alldata.message.goodstype || "-") + " ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("i18n_Order_date")))]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.Alldata.message.inputtime || "-"))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("p", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("i18n_Warehouse")))]),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.Alldata.waybilldetails.warehouse || "-")
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("i18n_warehosue_received_date")))
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.Alldata.waybilldetails.inwarehousetime || "-"
                        )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("p", [
                    _c("span", {}, [
                      _vm._v(_vm._s(_vm.$t("i18n_Payment_Method")) + " ")
                    ]),
                    _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.Alldata.waybilldetails.payType
                              ? _vm.Alldata.waybilldetails.payType === "PP"
                                ? _vm.$t("i18n_domestic_payment")
                                : _vm.$t("i18n_foreign_payment")
                              : "-"
                          ) +
                          "\n            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("i18n_custom_clearance_method")))
                    ]),
                    _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.Alldata.waybilldetails.declareType
                              ? _vm.Alldata.waybilldetails.declareType === "M"
                                ? _vm.$t("i18n_customs_declaration")
                                : _vm.$t("i18n_Tax_refund")
                              : "-"
                          ) +
                          "\n          "
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "jackCard", staticStyle: { padding: "20px" } }, [
        _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              attrs: {
                src: require("./../../../assets/receiveIcon.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  "margin-left": "10px",
                  "font-size": "20px",
                  "font-weight": "550"
                }
              },
              [_vm._v(_vm._s(_vm.$t("i18n_consignee_information")))]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "reCard" }, [
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "18px",
                "line-height": "40px",
                "font-weight": "600"
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.Alldata.message.cneename ||
                      _vm.$t("i18n_no_receiving_information")
                  ) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { "line-height": "40px" } }, [
            _vm._v(
              _vm._s(_vm.Alldata.message.rece_tel || "") +
                "\n        " +
                _vm._s(_vm.Alldata.message.rece_country || "") +
                "\n        " +
                _vm._s(_vm.Alldata.message.rece_city || "") +
                "\n\n        " +
                _vm._s(_vm.Alldata.message.rece_address || "")
            )
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.Alldata.message.isgetgoodstodoor
        ? _c(
            "div",
            {
              staticClass: "jackCard",
              staticStyle: {
                overflow: "hidden",
                background: "rgb(253 246 217)"
              }
            },
            [
              _c("div", { staticStyle: { padding: "10px 30px" } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "26rpx",
                      "font-family": "PingFang SC",
                      "font-weight": "500",
                      color: "#c19822",
                      "line-height": "40rpx"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "i18n_Please_ship_your_package_to_below_warehouse"
                        )
                      )
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { background: "#fff", padding: "15px 30px" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-family": "PingFang SC",
                        "font-weight": "550",
                        "line-height": "40px"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.Alldata.depwarehouse.warehouse || "") +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticStyle: { margin: "0 10px" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.Alldata.depwarehouse.tel || "") +
                        "\n      "
                    )
                  ]),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.Alldata.depwarehouse.province || "") +
                      "\n      " +
                      _vm._s(_vm.Alldata.depwarehouse.city || "") +
                      "\n      " +
                      _vm._s(_vm.Alldata.depwarehouse.area || "") +
                      "\n      " +
                      _vm._s(_vm.Alldata.depwarehouse.address || "") +
                      "\n    "
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.Alldata.message.issendgoodstodoor
        ? _c(
            "div",
            {
              staticClass: "jackCard",
              staticStyle: {
                overflow: "hidden",
                background: "rgb(253 246 217)"
              }
            },
            [
              _c("div", { staticStyle: { padding: "10px 30px" } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "26rpx",
                      "font-family": "PingFang SC",
                      "font-weight": "500",
                      color: "#c19822",
                      "line-height": "40rpx"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("i18n_pickup_cargo_at_below_warehouse"))
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { background: "#fff", padding: "5px 30px" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-family": "PingFang SC",
                        "font-weight": "550",
                        "line-height": "40px"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.Alldata.deswarehouse.warehouse || "") +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticStyle: { margin: "0 10px" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.Alldata.deswarehouse.tel || "") +
                        "\n      "
                    )
                  ]),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.Alldata.deswarehouse.province || "") +
                      "\n      " +
                      _vm._s(_vm.Alldata.deswarehouse.city || "") +
                      "\n      " +
                      _vm._s(_vm.Alldata.deswarehouse.area || "") +
                      "\n      " +
                      _vm._s(_vm.Alldata.deswarehouse.address || "") +
                      "\n    "
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "Blurb" }, [
        _c(
          "div",
          { staticClass: "tablebox" },
          [
            _c("h4", [_vm._v(_vm._s(_vm.$t("i18n_Forecast_pakcage_info")))]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: {
                  width: "94%",
                  "margin-left": "25px",
                  "margin-top": "20px"
                },
                attrs: {
                  border: "",
                  data: _vm.tableData_C1,
                  "tooltip-effect": "dark",
                  "header-cell-style": { background: "#F3F3F3" },
                  "summary-method": _vm.getSummaries,
                  "show-summary": ""
                },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: _vm.$t("i18n_Serial_number"),
                    width: "75px",
                    "min-width": "8%"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "goodname",
                    label: _vm.$t("i18n_Product_Name")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "goodstype",
                    label: _vm.$t("i18n_cargo_classification")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "weight",
                    label: _vm.$t("i18n_forecast_weight_kgs")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "cbm",
                    label: _vm.$t("i18n_forecast_volume_cbm")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "piece",
                    label: _vm.$t("i18n_forecast_quantity")
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tablebox" },
          [
            _c("h4", [_vm._v(_vm._s(_vm.$t("i18n_Accurated_package_info")))]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: {
                  width: "94%",
                  "margin-left": "25px",
                  "margin-top": "20px"
                },
                attrs: {
                  border: "",
                  data: _vm.tableData_C2,
                  "tooltip-effect": "dark",
                  "header-cell-style": { background: "#F3F3F3" },
                  "summary-method": _vm.getSummaries,
                  "show-summary": ""
                },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: _vm.$t("i18n_Serial_number"),
                    width: "75px",
                    "min-width": "8%"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "goodname",
                    label: _vm.$t("i18n_Product_Name")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "weight",
                    label: _vm.$t("i18n_actual_weight_kgs")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "cbm",
                    label: _vm.$t("i18n_actual_volume_cbm")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "piece",
                    label: _vm.$t("i18n_actual_quantity")
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "Information divbox", staticStyle: { width: "95%" } },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("i18n_shipping_fee_info"),
                    name: "second"
                  }
                },
                [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticStyle: {
                        width: "77%",
                        "margin-left": "25px",
                        "border-bottom": "none"
                      },
                      attrs: {
                        border: "",
                        data: _vm.tableData1,
                        "tooltip-effect": "dark",
                        "header-cell-style": { background: "#F3F3F3" }
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: _vm.$t("i18n_Serial_number"),
                          width: "75px",
                          "min-width": "8%"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.feeitem !==
                                  _vm.$t("i18n_Total_payment") &&
                                scope.row.feeitem !==
                                  _vm.$t("i18n_Covert_to_CNY")
                                  ? _c("span", [
                                      _vm._v(_vm._s(parseInt(scope.$index + 1)))
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "feeitem",
                          label: _vm.$t("i18n_cost_category"),
                          "min-width": "8%"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "amountBefore",
                          label: _vm.$t("i18n_estimated_cost"),
                          "min-width": "8%"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "amount",
                            label: _vm.$t("i18n_Estimate_inWarehouse_cost"),
                            "min-width": "8%"
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("i18n_Estimate_inWarehouse_cost")
                                  ) +
                                  "\n              "
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.$t("actual_fee_after_loading"),
                                    placement: "top"
                                  }
                                },
                                [_c("i", { staticClass: "el-icon-question" })]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: {
                        width: "77%",
                        "margin-left": "25px",
                        "border-top": "none",
                        "margin-top": "0px"
                      },
                      attrs: {
                        border: "",
                        data: _vm.twotableData,
                        "cell-style": { padding: "5px 0px" },
                        "show-header": false
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "",
                          width: "75px",
                          "min-width": "8%"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.feeitem !==
                                  _vm.$t("i18n_Total_payment") &&
                                scope.row.feeitem !==
                                  _vm.$t("i18n_Covert_to_CNY")
                                  ? _c("span", [
                                      _vm._v(_vm._s(parseInt(scope.$index + 1)))
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "feeitem", label: "", "min-width": "8%" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "amountBefore",
                          label: "",
                          "min-width": "8%"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "amount", label: "", "min-width": "8%" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: { label: _vm.$t("i18n_tracking_info"), name: "third" }
                },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "trackTable",
                      attrs: {
                        border: "",
                        data: _vm.tableData,
                        "tooltip-effect": "dark",
                        "header-cell-style": { background: "#F3F3F3" }
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Order_Status"),
                          prop: "orderStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Pickup_Status"),
                          prop: "THStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_warehouse_status"),
                          prop: "JCStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_LCL_status"),
                          prop: "PGStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Cabinet_status"),
                          prop: "DGStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Trunk_status"),
                          prop: "GXStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Customs_clearance_status"),
                          prop: "QGStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Distribution_Center_Status"),
                          prop: "FBZXStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_delivery_status"),
                          prop: "PSStatus",
                          width: "120px",
                          align: "center"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19669d7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19669d7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/BulkOrder/OrderDetails.vue
// module id = null
// module chunks = 